import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const Error = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path d="M28 5.25A22.75 22.75 0 1 0 50.75 28 22.794 22.794 0 0 0 28 5.25ZM26.25 17.5a1.75 1.75 0 0 1 3.5 0v12.25a1.75 1.75 0 0 1-3.5 0V17.5ZM28 40.25A2.625 2.625 0 1 1 28 35a2.625 2.625 0 0 1 0 5.25Z" />
  </svg>);
export default Error;